import { Controller } from "@hotwired/stimulus";
import { application } from "src";
import { toMilliseconds, toSeconds } from "@fretadao/f-js-utils";
import { removeClass } from "@fretadao/f-js-dom";
import { API } from '../../../src/api';

application.register('ride-request-tracking', class extends Controller {
  static targets = ['timer', 'message'];
  static values = { voucherCode: String };

  toleranceInSeconds = toSeconds(2, 'minutes');
  pooling = null;
  timer = null;

  connect() {
    this.polling = setInterval(this.#getCurrentStatus.bind(this), toMilliseconds(5, 'seconds'));
    this.#startTimer();
  }

  #getCurrentStatus() {
    API.rideRequest.api.voucherTripStatus(this.voucherCodeValue).then((trip) => {
      if (trip.status === 'failed') this.#tripFailed(trip);

      if (trip.riderTrackingUrl) {
        gtag('event', 'transporte_individual_acompanhamento', { 'event_label': trip.status });
        window.location.href = trip.riderTrackingUrl;
      }
    });
  }

  #startTimer() {
    let countSeconds = 0;
    this.timer = setInterval(() => {
      countSeconds++;

      if(countSeconds === this.toleranceInSeconds) this.#showTimerElement();

      const seconds = String(countSeconds % 60).padStart(2, '0');
      const minutes = String(Math.floor(countSeconds / 60)).padStart(2, '0');
      this.timerTarget.textContent = `Aguardando à ${minutes}:${seconds}`;
    }, toMilliseconds(1, 'seconds'));
  }

  #showTimerElement() {
    removeClass(this.timerTarget, 'hidden');
  }

  #tripFailed(trip) {
    clearInterval(this.polling);
    clearInterval(this.timer);
    this.messageTarget.textContent = 'Ocorreu um erro com a sua viagem, por favor, entre em contato com a nossa central de atendimento.';
    this.#openChat();
    gtag('event', `transporte_individual_acompanhamento_${trip.status}`, { 'event_label': trip.status, 'error': trip.statusData?.error });
  }

  #openChat() {
    zE('messenger', 'open');
  }
});
